import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { VoucherCategory, VoucherTypeIds, } from '@debbie/common/dist/economy/vouchers/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { selectVoucherTypes, selectVoucherTypesIsLoading, } from '@debbie/cortex/dist/economy/selectors.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { Panel, Button, ButtonDrop } from '../../index.js';
import noData from '../../../assets/images/no-data.svg';
import CaseVouchers from '../../economy/case-vouchers/CaseVouchers.js';
import CreateVoucher from '../../economy/CreateVoucher/index.js';
import PlaceholderLoader from '../../PlaceholderLoader.js';
import THEME from '../../../theme.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
const Economy = (props) => {
    const [addVoucherOpen, setAddVoucherOpen] = useState(false);
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const singleCase = useSelector((s) => selectCaseById(s, props.caseId));
    const voucherTypes = useSelector(selectVoucherTypes);
    const voucherTypesIsLoading = useSelector(selectVoucherTypesIsLoading);
    const caseVouchers_ = useCaseVouchersByCase(singleCase?.caseId);
    const _caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    let voucherCount = 0;
    if (_caseVouchers) {
        voucherCount = _caseVouchers.length;
    }
    const decoratedCaseVouchers = _caseVouchers &&
        _caseVouchers.map((caseVoucher) => {
            return { ...caseVoucher, children: [] };
        });
    useEffect(() => {
        c.cases.getById(props.caseId);
    }, [props.caseId]);
    useEffect(() => {
        if (!voucherTypes && !voucherTypesIsLoading && tenant) {
            c.economy.getVoucherTypes();
        }
    }, [tenant]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Panel, null, lang.cases.newCaseEconomyExplainer),
        React.createElement(Panel, { header: React.createElement(Header, null,
                React.createElement("div", null, lang.economy.caseEconomy),
                React.createElement(HeaderRight, null,
                    React.createElement(ButtonDrop, { open: addVoucherOpen, onOpen: () => setAddVoucherOpen(true), onClose: () => setAddVoucherOpen(false), size: "mini" }, singleCase && (React.createElement(CreateVoucher, { caseId: singleCase.caseId, creditorId: singleCase.creditorId, onCreate: () => setAddVoucherOpen(false), categoryFilter: [
                            VoucherCategory.PRINCIPAL,
                            VoucherCategory.INTEREST,
                            VoucherCategory.COST,
                            VoucherCategory.INTEREST,
                        ], voucherTypeFilter: [VoucherTypeIds.PRINCIPAL], typeMap: {
                            [VoucherCategory.COST]: (voucherTypes) => {
                                return voucherTypes
                                    .filter((voucherType) => [
                                    VoucherTypeIds.COLLECTIONFEE,
                                    VoucherTypeIds.REMINDERFEE,
                                ].includes(voucherType.voucherTypeId))
                                    .map((vt) => ({
                                    label: lang.economyVoucherTypeLabels[vt.voucherTypeId],
                                    type: vt,
                                }));
                            },
                        }, defaultImposedByCreditor: {
                            [VoucherTypeIds.COLLECTIONFEE]: true,
                            [VoucherTypeIds.REMINDERFEE]: true,
                        }, caseVouchers: decoratedCaseVouchers || [], singleCase: singleCase }))))) },
            singleCase && decoratedCaseVouchers ? (React.createElement(CaseVouchers, { caseVouchers: decoratedCaseVouchers, singleCase: singleCase })) : (React.createElement(PlaceholderLoader, null)),
            singleCase && voucherCount === 0 && (React.createElement(NoDataWrapper, null,
                React.createElement(NoDataImage, { src: noData }),
                React.createElement("h2", null, lang.cases.noDebts),
                React.createElement("p", null, lang.cases.noDebtsExplainer)))),
        React.createElement("div", null,
            React.createElement(Button, { disabled: !(singleCase && voucherCount), onClick: async () => {
                    c.cases.getById(props.caseId);
                    c.redirect.redirect(`/cases/${props.caseId}`);
                } }, lang.creditors.next),
            React.createElement("p", { onClick: async () => {
                    c.cases.getById(props.caseId);
                    c.redirect.redirect(`/cases/${props.caseId}`);
                }, style: {
                    display: 'inline-block',
                    cursor: 'pointer',
                    marginLeft: '1em',
                    color: THEME.COLOR_GREY,
                } }, lang.misc.skip))));
};
export default Economy;
const Header = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const HeaderRight = styled.div `
  display: flex;
  align-items: center;
`;
const NoDataImage = styled.img `
  width: 90%;
  max-width: 200px;
  margin-bottom: 2em;
`;
const NoDataWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 20px;

  h2,
  p {
    margin: 0;
    margin-bottom: 1em;
  }
`;
//# sourceMappingURL=Economy.js.map